<template>
	<div class="booker-calendar">
		<DatePicker
			:key="key"
			v-model.range="range"
			borderless
			transparent
			title-position="left"
			:columns="isMobile_lg ? 1 : 2"
			:rows="isMobile_lg ? 4 : 1"
			:step="1"
			:attributes="attrs"
			:masks="masks"
			:min-date="new Date()"
			:max-date="maxDate"
			trim-weeks
			expanded
			:locale="locale"
			color="green"
			mode="date"
			:first-day-of-week="2"
			class="booker-calendar__range">
			<template #header-prev-button>
				<div class="booker-calendar__inputs">
					<GlobalIcon name="arrow-left" :height="16"></GlobalIcon>
				</div>
			</template>
			<template #header-next-button>
				<div class="booker-calendar__inputs">
					<GlobalIcon name="arrow-right" :height="16"></GlobalIcon>
				</div>
			</template>
		</DatePicker>
	</div>
</template>

<script setup lang="ts">
import 'v-calendar/style.css'
import { DatePicker } from 'v-calendar'
const props = defineProps<{
	disabled?: boolean
	startDate?: Date | string | number
	endDate?: Date | string | number
}>()

const { isMobile_lg } = useWindowWidth()
const { locale } = useI18n()

const attrs = ref([
	{
		key: 'today',
		dot: true,
		dates: new Date(),
	},
])

const key = ref(0)
const masks = ref({
	input: 'DD MMM YYYY',
	title: 'MMMM',
})

const range = ref<DateRange>({
	start: props.startDate,
	end: props.endDate,
})

const maxDate = new Date()
maxDate.setMonth(maxDate.getMonth() + 3)

// const computedValue = (inp: any) => {
// 	return inp.start ? `${inp.start.toUpperCase()} - ${inp.end.toUpperCase()}` : ''
// }

const emit = defineEmits<{
	(e: 'updateCalendar', v: any): void
}>()

watch(
	() => range.value,
	(newValue) => {
		emit('updateCalendar', newValue)
	},
)

watch(
	() => props.startDate,
	(newValue) => {
		key.value++
		range.value.start = newValue
	},
	{ immediate: true },
)

watch(
	() => props.endDate,
	(newValue) => {
		key.value++
		range.value.end = newValue
	},
	{ immediate: true },
)
</script>

<style lang="scss">
@import './Calendar.scss';
</style>
